require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-fin-magazine-paul-conrad.json") })
        }
      }, "path---journal-fin-magazine-paul-conrad");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-fin-magazine-paul-conrad!./.cache/json/journal-fin-magazine-paul-conrad.json
// module id = 487
// module chunks = 231608221292675